import React, { useEffect, useState } from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { UrlApiEnvasado } from "../../../../services/apirest";

// ICONOS
import CircularProgress from "@mui/material/CircularProgress";

export default function BasicPie() {
  const [loading, setLoading] = useState(true);
  const [datosGrafico, setDatosGrafico] = useState([]);

  const obtenerDatosGrafico = async (endpoint, label) => {
    try {
      setLoading(true);
      const response = await fetch(`${UrlApiEnvasado}${endpoint}`);
      const data = await response.json();

      console.log(`Nuevos datos del gráfico (${label}):`, data);

      setDatosGrafico((prevData) => [...prevData, { label, data }]);
      setLoading(false);
    } catch (error) {
      console.error(`Error al obtener datos del gráfico (${label}):`, error);
      setLoading(false);
    }
  };

  // Organizar datos
  // PARA EL CHART
  const datosParaGrafico = datosGrafico.map((conjunto) => ({
    label: conjunto.label,
    value: conjunto.data.length, // Obtener la cantidad de elementos en el conjunto
  }));

  // Datos para la leyenda
  const datosLeyenda = datosParaGrafico.map((item) => ({
    label: `${item.label}: ${item.value}`,
    value: item.value,
  }));

  useEffect(() => {
    // Obtener (Paso el parametro de la URL y el "Label")
    obtenerDatosGrafico("/envasado/movil/mbenz", "Mercedes Benz");
    obtenerDatosGrafico("/envasado/movil/hyundai", "Hyundai");
    obtenerDatosGrafico("/envasado/movil/ford", "Ford");
    obtenerDatosGrafico("/envasado/movil/chevrolet", "Chevrolet");
    obtenerDatosGrafico("/envasado/movil/inactivos", "Inactivos");
  }, []); // Se ejecuta solo una vez al montar el componente

    // Asignar colores manualmente a cada sección del gráfico
    const colors = ["#4CAF50", "#FF9800", "#2196F3", "#F44336", "#9C27B0"];

  return (
    <>
      {loading ? (
        <div style={{ position: "relative", minHeight: "200px" }}>
          <CircularProgress
            size={60}
            style={{
              position: "absolute",
              top: "50%",
              left: "45%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <PieChart
          // series={[
          //   {
          //     data: datosParaGrafico,
          //     highlightScope: { faded: "global", highlighted: "item" },
          //     faded: {
          //       innerRadius: 30,
          //       additionalRadius: -30,
          //       color: "gray",
          //     },
          //   },
          // ]}
          series={[
            {
              data: datosParaGrafico.map((item, index) => ({
                ...item,
                color: colors[index % colors.length], // Asigna colores a los datos
              })),
              highlightScope: { faded: "global", highlighted: "item" },
              faded: {
                innerRadius: 30,
                additionalRadius: -30,
                color: "gray",
              },
            },
          ]}
          slotProps={{
            legend: {
              hidden: true, // Oculta la leyenda predeterminada
            },
          }}
          width={400}
          height={230}
          style={{
            position: "relative",
          }}
        />
        <div 
        // style={{ marginLeft: '20px' }}
        >
          {datosParaGrafico.map((item, index) => (
            <div key={index} style={{ marginBottom: '8px' }}>
              <span
                style={{
                  display: 'inline-block',
                  width: '12px',
                  height: '12px',
                  // backgroundColor: item.color || '#000', // Ajusta según el color del gráfico
                  backgroundColor: colors[index % colors.length], // Usa el mismo color que en el gráfico
                  marginRight: '8px',
                }}
              ></span>
              {item.label}: {item.value}
            </div>
          ))}
        </div>
      </div>
      )}
    </>
  );
}
